import { render, staticRenderFns } from "./afterSaleWaitDealList.vue?vue&type=template&id=6462a2ee&scoped=true&"
import script from "./afterSaleWaitDealList.vue?vue&type=script&lang=js&"
export * from "./afterSaleWaitDealList.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleWaitDealList.vue?vue&type=style&index=0&id=6462a2ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6462a2ee",
  null
  
)

export default component.exports